export function Button({
  variant = "primary", // "primary" | "ghost"
  as = "a",
  href,
  icon,
  iconPosition = "trailing", // "leading" | "trailing"
  size = "md", // "md" | "sm"
  children,
  className = "",
  ...rest
}) {
  const Tag = as;
  const cls = `btn btn-${variant} btn-${size} ${className}`.trim();
  const iconEl = icon ? <span className="btn-icon">{icon}</span> : null;
  return (
    <Tag className={cls} href={Tag === "a" ? href : undefined} {...rest}>
      {iconPosition === "leading" && iconEl}
      {children}
      {iconPosition === "trailing" && iconEl}
    </Tag>
  );
}
